import { render, staticRenderFns } from "./ProductsStockList.vue?vue&type=template&id=fffbd3d8&scoped=true"
import script from "./ProductsStockList.vue?vue&type=script&lang=js"
export * from "./ProductsStockList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fffbd3d8",
  null
  
)

export default component.exports